import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Promotion Management
    SETTING_LOAD_PROMOTION_CATEGORY,
    SETTING_CREATE_PROMOTION_CATEGORY,
    SETTING_UPDATE_PROMOTION_CATEGORY,
    SETTING_DELETE_PROMOTION_CATEGORY,

    SETTING_LOAD_PROMOTION,
    SETTING_CREATE_PROMOTION,
    SETTING_UPDATE_PROMOTION,
    SETTING_DELETE_PROMOTION,

    // SETTING_UPDATE_PROMOTION_STATUS,
    // END Promotion Management

} from "../../actions";

import {
    // Promotion Management
    settingGetPromotionCategory,
    settingAddPromotionCategory,
    settingUpdatePromotionCategory,
    settingDeletePromotionCategory,

    settingGetPromotion,
    settingAddPromotion,
    settingUpdatePromotion,
    settingDeletePromotion,
    // settingUpdateChangeStatusPromotion,

    // END Promotion Management

} from "../../../helpers/setting-api";

import {
    getPromotionCategory,
    getPromotionCategorySuccess,
    getPromotion,
    getPromotionSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Promotion Management
function* settingManagementLoadPromotionCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetPromotionCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_promotion_category,
                    value: item.id_promotion_category,
                }
            ));
            yield put(getPromotionCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddPromotionCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddPromotionCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPromotionCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdatePromotionCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdatePromotionCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPromotionCategory({ spa_id: payload.spa_id }, token));
            yield put(getPromotion({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeletePromotionCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeletePromotionCategory(items, token);
        if (dataRes.status === 'success') yield put(getPromotionCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadPromotion({ payload, token }) {
    try {
        const dataRes = yield settingGetPromotion(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_promotion,
                    value: item.id_promotion,
                }
            ));
            yield put(getPromotionSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddPromotion({ payload, token }) {
    try {
        const dataRes = yield settingAddPromotion(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPromotion({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdatePromotion({ payload, token }) {
    try {
        const dataRes = yield settingUpdatePromotion(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPromotion({ spa_id: payload.spa_id }, token));
            // yield put(getPromotionCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementChangeStatusPromotion({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateChangeStatusPromotion(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPromotion({ spa_id: payload.spa_id }, token));

//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

function* settingManagementDeletePromotion({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeletePromotion(items, token);
        if (dataRes.status === 'success') yield put(getPromotion({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Promotion Management

// Promotion Management
export function* watchLoadPromotionCategory() {
    yield takeEvery(
        SETTING_LOAD_PROMOTION_CATEGORY,
        settingManagementLoadPromotionCategory
    );
}
export function* watchAddPromotionCategory() {
    yield takeEvery(
        SETTING_CREATE_PROMOTION_CATEGORY,
        settingManagementAddPromotionCategory
    );
}
export function* watchUpdatePromotionCategory() {
    yield takeEvery(
        SETTING_UPDATE_PROMOTION_CATEGORY,
        settingManagementUpdatePromotionCategory
    );
}
export function* watchDeletePromotionCategory() {
    yield takeEvery(
        SETTING_DELETE_PROMOTION_CATEGORY,
        settingManagementDeletePromotionCategory
    );
}

export function* watchLoadPromotion() {
    yield takeEvery(
        SETTING_LOAD_PROMOTION,
        settingManagementLoadPromotion
    );
}
export function* watchAddPromotion() {
    yield takeEvery(
        SETTING_CREATE_PROMOTION,
        settingManagementAddPromotion
    );
}
export function* watchUpdatePromotion() {
    yield takeEvery(
        SETTING_UPDATE_PROMOTION,
        settingManagementUpdatePromotion
    );
}
// export function* watchChangeStatusPromotion() {
//     yield takeEvery(
//         SETTING_UPDATE_PROMOTION_STATUS,
//         settingManagementChangeStatusPromotion
//     );
// }
export function* watchDeletePromotion() {
    yield takeEvery(
        SETTING_DELETE_PROMOTION,
        settingManagementDeletePromotion
    );
}

// END Promotion Management

export default function* rootSaga() {
    yield all([
        //  Promotion Management 
        fork(watchLoadPromotionCategory),
        fork(watchAddPromotionCategory),
        fork(watchUpdatePromotionCategory),
        fork(watchDeletePromotionCategory),

        fork(watchLoadPromotion),
        fork(watchAddPromotion),
        fork(watchUpdatePromotion),
        // fork(watchChangeStatusPromotion),
        fork(watchDeletePromotion),

    ])
}